<ab-connecting-splash-screen *ngIf="frameIsInSyncMode"></ab-connecting-splash-screen>
<iframe #abFrame src="about:blank" (load)="onIframeLoaded()" [hidden]="frameIsInSyncMode"></iframe>
